import { Table } from "@fluidattacks/design";
import type { ColumnDef } from "@tanstack/react-table";
import { useMemo, useState } from "react";
import type { FC } from "react";

import { formatPackagesColumn } from "./formatters/format-details-column";
import { useDockerImagesQuery } from "./hooks";
import type { TDockerImage } from "./hooks";

import { useTable } from "hooks/use-table";

interface IDockerImagesTab {
  readonly groupName: string;
}

const DockerImagesTab: FC<IDockerImagesTab> = ({
  groupName,
}): React.JSX.Element => {
  const { dockerImages, loading } = useDockerImagesQuery(groupName);
  const [search, setSearch] = useState("");
  const formattedDockerImages = useMemo((): TDockerImage[] => {
    return dockerImages.filter((dockerImage): boolean =>
      dockerImage.uri.toLowerCase().includes(search.toLowerCase()),
    );
  }, [dockerImages, search]);

  const columns: ColumnDef<TDockerImage>[] = [
    { accessorKey: "uri", header: "URI" },
    { accessorKey: "root.nickname", header: "Root nickname" },
    { cell: formatPackagesColumn, header: "Packages" },
  ];
  const { table } = useTable({
    columns,
    data: formattedDockerImages,
    id: "supply-chain-docker-images-table",
    options: {
      actionsOptions: { onSearch: setSearch, search },
      filtersMode: "client-side",
      loading,
      paginationMode: "client-side",
    },
    total: dockerImages.length,
  });

  return (
    <Table table={table}>
      <Table.Options>
        <Table.Controls>
          <div id={"actions-container"} />
        </Table.Controls>
      </Table.Options>
      <Table.Content />
      <Table.Footer />
    </Table>
  );
};

export { DockerImagesTab };
